/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./global-config-group-item.vue?vue&type=template&id=395a4748&scoped=true&"
import script from "./global-config-group-item.vue?vue&type=script&lang=js&"
export * from "./global-config-group-item.vue?vue&type=script&lang=js&"
import style0 from "./global-config-group-item.vue?vue&type=style&index=0&id=395a4748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395a4748",
  null
  
)

export default component.exports